import React from 'react';
import PropTypes from 'prop-types';
import {
    BoxscoreTeamNoteWrapper
} from '../BoxscoreTeam.style';

const BoxscoreTeamNotes = ({
    label = '',
    value = '',
    index
}) => {
    return (
        <BoxscoreTeamNoteWrapper key={`teamnote-${index}`}>
            {label}{value !== '' ? `-${value}` : ''};
        </BoxscoreTeamNoteWrapper>
    );
};

BoxscoreTeamNotes.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number
};

export default BoxscoreTeamNotes;
